import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-email-tooltip',
    templateUrl: './email-tooltip.component.html',
    styleUrls: ['./email-tooltip.component.scss'],
    standalone: false
})
export class EmailTooltipComponent {

 @Input() email: string;

  constructor(private popoverCtrl: PopoverController) {}

  close() {
    this.popoverCtrl.dismiss();
  }

}
